import { useQuery } from "@tanstack/react-query"
import { useCallback } from "react"
import { PacOption } from "@/components/TopNavigation/components/MultiPacSelector/types"
import { AVAILIABLE_PACS_QUERY_KEY } from "@/components/TopNavigation/components/MultiPacSelector/consts"

const { QuorumUser } = DjangIO.app.userdata.models

export const fetchAvailablePacs: () => Promise<[PacOption[], string]> = async () => {
    const { allowed_pacs, current_pacc_pac_id } = await QuorumUser.objects.get().action("get_available_pacs").GET()
    return [allowed_pacs, current_pacc_pac_id]
}

const selectAvailablePacs = (data: [PacOption[], string]) => ({ options: data[0], selectedPac: data[1] })

export const useAvailablePacs = () =>
    useQuery({
        queryKey: [AVAILIABLE_PACS_QUERY_KEY],
        queryFn: fetchAvailablePacs,
        select: useCallback((data) => selectAvailablePacs(data), []),
        staleTime: Infinity,
        refetchOnWindowFocus: false,
    })

export const saveNewSelectedPac = async (pacID: string) => {
    return await QuorumUser.objects.use_action("set_pacc_pac").update({ pac_id: pacID }).PATCH()
}
